/* RESPONSIBLE TEAM: team-automation-foundations */
import type AppService from 'embercom/services/app-service';
import Route from '@ember/routing/route';
import { inject as service } from '@ember/service';
import type Router from '@ember/routing/router-service';

export default class AiChatbotRoute extends Route {
  @service declare router: Router;
  @service declare appService: AppService;

  buildRouteInfoMetadata() {
    return {
      responsibleTeam: 'team-automation-foundations',
    };
  }
  beforeModel(transition: any) {
    let target = transition.intent.url;
    this.router.transitionTo(target.replace('ai-chatbot', 'fin-ai-agent'));
  }
}
